'use client';

import { createContext, useContext } from 'react';
import { useTimeZone } from './useTimeZone';
import { ITimezone } from '@framework/timezone/vo/Timezone';

// @ts-ignore
export const TimeZoneContext = createContext<ReturnType<typeof useTimeZone>>(null);

export const useTimeZoneContext = () => {
  const context = useContext(TimeZoneContext);
  if (!context) {
    throw new Error('useTimeZoneContext must be used within a TimeZoneContext');
  }
  return context;
};

interface IProps {
  getList?: () => Promise<ITimezone[]>,
  timeZoneList?: ITimezone[],
}

const TimeZoneContextProvider = ({ children, getList, timeZoneList = [] }: React.PropsWithChildren<IProps>) => {
  return <TimeZoneContext.Provider value={ useTimeZone(getList, timeZoneList) }>{ children }</TimeZoneContext.Provider>;
};

export default TimeZoneContextProvider;
